import { ZyExploreIcon } from '@/components/tiptap-editor/tiptap-icons/zyexplore-icon';
import { isSelectionTopNode } from '@/lib/zy-tiptap-utils';
import { forwardRef } from 'react';
import { GenericExtensionButton, type GenericExtensionButtonProps } from '../generic-extension-button';

export const ZyExploreButton = forwardRef<
    HTMLButtonElement,
    Omit<GenericExtensionButtonProps, 'extensionName' | 'extensionType' | 'icon' | 'label' | 'command'>
>((props, ref) => (
    <GenericExtensionButton
        extensionName="zyExplore"
        extensionType="node"
        icon={ZyExploreIcon}
        isDisabled={editor => !isSelectionTopNode(editor)}
        label="Insert zyExplore"
        command={editor => editor.commands.insertZyExplore()}
        ref={ref}
        {...props}
    />
));

ZyExploreButton.displayName = 'ZyExploreButton';

export default ZyExploreButton;
